import functions from "../../../../../world/spa/libs/vuexFunctions";

export default {
    namespaced: true,
    state: {
        objs: []
    },
    getters: {
        ...functions.createDefaultGetters(['idWorldWorkCost']),
        getByProject: (state) => idProject => {
            return state.objs.filter(wc => wc.project === idProject);
        }
    },
    mutations: {
        ...functions.createDefaultMutations(['idWorldWorkCost'])
    },
    actions: {
        ...functions.createDefaultActionsWithStore(['idWorldWorkCost'])
    },
}